/**
 * Demo clients keep unique technical emails in the DB; consultants see a simple placeholder in the UI.
 */
export function getClientDisplayEmail(client) {
  if (!client) return '';
  if (client.isDemo) {
    const first = (client.client_firstName || '')
      .trim()
      .toLowerCase()
      .normalize('NFD')
      .replace(/[\u0300-\u036f]/g, '')
      .replace(/\s+/g, '');
    if (first) {
      return `${first}@example.com`;
    }
    const local = String(client.client_Username || '').split('.')[0] || 'client';
    return `${local}@example.com`;
  }
  return client.client_Email || '';
}
